<div class="dialog-title" mat-dialog-title>
  {{'app.gdpr-dialog.title' | translate}}
  <button mat-icon-button [mat-dialog-close]="false">
    <fa-icon [icon]="faTimes" size="lg"></fa-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="gdpr-content">
    <div [innerHTML]="gdprContent"></div>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-raised-button (click)="onOkClick()" type="button" color="primary">
    {{'common.ok' | translate}}
  </button>
</div>